import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { GridRowModes } from "@mui/x-data-grid";
import { isObjEmpty } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { generateRandomId } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import { saveOrDeleteMsg } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant";
import { newRow } from "./constants";
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import ADataGrid from "views/pages/manage/common/data-grid/EnhanceDataGrid";
import { editCellContainerStyle } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { selectStyles, inputStyles } from "./constants";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import { Tooltip } from "@mui/material";
import moment from "moment";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import { regex } from "views/pages/manage/common/constant/regex/index";
import { ActionsCellComponent, StatusCellComponent } from 'views/pages/manage/masters/studentFinancials/paymentGatewaysConfiguration/common';
import { ReactComponent as CancelIcon } from 'assets/img/svg/RedCancel.svg';
import { LastUpdatedDetails, getFormattedDate } from "views/pages/manage/employeeManagement/userProfile/helper";
import ALoader from "views/pages/manage/common/a-loader";

const ListComponent = forwardRef(({
  currentPage = 0,
  nextButtonHandler,
  dropdownData,
  rows,
  createUpdateHandler,
  deleteHandler,
  currPageSize,
  totalRecords,
  isUpdatePermission,
  isDeletePermission,
  loading
}, ref) => {

  const [rowModesModel, setRowModesModel] = useState({});
  const [rowData, setRowData] = useState(rows);
  const [rowForm, setRowForm] = useState({});

  const { allCountries, allBanks, thirdPartyPaymentMode } = dropdownData;

  useEffect(() => {
    setRowData(rows)
  }, [rows])

  const rowFormHandler = (value, key) => {
    setRowForm((prev) => ({ ...prev, [key]: value }))
  }

  const startEditing = (id, form) => {
    setRowModesModel((oldModel) => ({ [id]: { mode: GridRowModes.Edit } }));
    setRowForm(form);
  };


  const stopEditing = () => {
    const currForm = { ...rowForm };
    setRowModesModel((oldModel) => ({
      [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true },
    }));
    setRowForm({});
  };

  const handleEditClick = (params) => {
    if (!isObjEmpty(rowForm)) {
      failureToast(saveOrDeleteMsg);
    } else {
      startEditing(params?.id, params?.row);
    }
  };

  const handleDeleteClick = (params) => {
    if (!isObjEmpty(rowForm)) {
      failureToast(saveOrDeleteMsg);
    } else {
      deleteHandler(params?.row)
    }
  }

  const handleCancelClick = async (params) => {
    if (params?.row?.isNew) {
      setRowData(rows);
      setRowForm({});
    } else {
      stopEditing(params?.id);
    }
  };

  const handleSaveClick = async (params) => {
    createUpdateHandler(rowForm);
  };

  const addNewRow = async () => {
    if (!isObjEmpty(rowForm)) {
      failureToast(saveOrDeleteMsg);
    } else {
      let randomId = generateRandomId();
      let emptyRow = {
        ...newRow,
        isNew: true,
        id: randomId
      };
      startEditing(randomId, emptyRow);
      setRowData((prev) => [emptyRow, ...prev]);
    }
  };

  useImperativeHandle(ref, () => ({
    addNewRow: addNewRow,
    startEditing: startEditing,
    stopEditing: stopEditing,
  }));

  const columns = [
    new AGridColDef("country", "Country", false)
      .setMinWidth(90)
      .editable(true)
      .setFlex(1)
      .renderCellComponent((params) => (
        params?.value ? <Tooltip title={params?.value?.label}>
          <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
        </Tooltip> : <div>-</div>
      ))
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AAutoComplete
            currentValue={rowForm?.country}
            handleChange={(value) => {
              rowFormHandler(value, "country");
              rowFormHandler(value?.value, "countryCode");
            }}
            items={allCountries}
            isMulti={false}
            style={selectStyles}
            autoFocus={params?.hasFocus}
          />
        </div>
      )),
    new AGridColDef("countryCode", "Country Code", false)
      .setMinWidth(130)
      .editable(true)
      .setFlex(1)
      .renderCellComponent((params) => (
        params?.value ? <div><Tooltip title={params?.value}>
          <div className={`ellipsis-text-container`}>{params?.value}</div>
        </Tooltip></div> : <div>-</div>
      ))
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AInput
            value={rowForm?.countryCode}
            // handler={(val) => {
            //   rowFormHandler(val, "countryCode");
            // }}
            placeholder={""}
            disabled={true}
            style={inputStyles}
          />
        </div>)),
    new AGridColDef("thirdPartyCode", "Third party code", false)
      .setMinWidth(130)
      .editable(true)
      .setFlex(1)
      .renderCellComponent((params) => (
        params?.value?.value ? <div><Tooltip title={params?.value?.label}>
          <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
        </Tooltip></div> : <div>-</div>
      ))
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AAutoComplete
            currentValue={rowForm?.thirdPartyCode}
            handleChange={(value) => {
              rowFormHandler(value, "thirdPartyCode")
              rowFormHandler(value?.value, "name")
            }}
            items={thirdPartyPaymentMode}
            isMulti={false}
            style={selectStyles}
            autoFocus={params?.hasFocus}
          />
        </div>
      )),
    new AGridColDef("name", "Third party name", false)
      .setMinWidth(150)
      .editable(true)
      .setFlex(1)
      .renderCellComponent((params) => (
        params?.value ? <div><Tooltip title={params?.value}>
          <div className={`ellipsis-text-container`}>{params?.value}</div>
        </Tooltip></div> : <div>-</div>
      ))
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AInput
            value={rowForm?.name}
            handler={(val) => {
              rowFormHandler(val, "name");
            }}
            placeholder={""}
            disabled={true}
            style={inputStyles}
          />
        </div>)),
    new AGridColDef("beneficiaryName", "Beneficiary Name", false)
      .setMinWidth(160)
      .setFlex(1)
      .editable(true)
      .renderCellComponent((params) => (
        params?.value ? <Tooltip title={params?.value}>
          <div className={`ellipsis-text-container`}>{params?.value}</div>
        </Tooltip> : <div>-</div>
      ))
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AInput
            value={rowForm?.beneficiaryName}
            handler={(val) => {
              rowFormHandler(val, "beneficiaryName");
            }}
            placeholder={""}
            style={inputStyles}
            regex={regex?.alphabetsWithSpace}
          />
        </div>
      )),
    new AGridColDef("accountNumber", "Account Number", false)
      .setMinWidth(170)
      .setFlex(0.9)
      .editable(true)
      .renderCellComponent((params) => (
        params?.value ? <div><Tooltip title={params?.value}>
          <div className={`ellipsis-text-container`}>{params?.value}</div>
        </Tooltip></div> : <div>-</div>
      ))
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AInput
            value={rowForm?.accountNumber}
            handler={(val) => {
              if (val?.length <= 18) {
                rowFormHandler(val, "accountNumber");
              }
            }}
            regex={regex?.numeric}
            style={inputStyles}
          />
        </div>
      )),
    new AGridColDef("bank", "Bank", false)
      .setMinWidth(220)
      .editable(true)
      .setFlex(1)
      .renderCellComponent((params) => (
        params?.value ? <div><Tooltip title={params?.value?.label}>
          <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
        </Tooltip></div> : <div>-</div>
      ))
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AAutoComplete
            currentValue={rowForm?.bank}
            handleChange={(value) => rowFormHandler(value, "bank")}
            items={allBanks}
            isMulti={false}
            style={selectStyles}
            autoFocus={params?.hasFocus}
          />
        </div>
      )),
    new AGridColDef("ifsc", "IFSC", false)
      .setMinWidth(110)
      .setFlex(0.9)
      .editable(true)
      // .setValueGetter((params) => params?.value)
      .renderCellComponent((params) => (
        params?.value ? <div><Tooltip title={params?.value}>
          <div className={`ellipsis-text-container`}>{params?.value}</div>
        </Tooltip></div> : <div>-</div>
      ))
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AInput
            value={rowForm?.ifsc}
            handler={(val) => {
              if (val?.length <= 11) {
                rowFormHandler(val, "ifsc");
              }
            }}
            regex={regex?.alphaNumeric}
            style={inputStyles}
          />
        </div>
      )),
    new AGridColDef("phoneNumber", "Phone number", false)
      .setMinWidth(120)
      .setFlex(0.9)
      .editable(true)
      .renderCellComponent((params) => (
        params?.value ? <div><Tooltip title={params?.value}>
          <div className={`ellipsis-text-container`}>{params?.value}</div>
        </Tooltip></div> : <div>-</div>
      ))
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AInput
            value={rowForm?.phoneNumber}
            handler={(val) => {
              rowFormHandler(val, "phoneNumber");
            }}
            regex={regex?.numeric}
            maxLength={10}
            style={inputStyles}
          />
        </div>
      )),
    new AGridColDef("updatedOn", "Last Updated On", false)
      .setMinWidth(250)
      .editable(true)
      .setFlex(1)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip
            title={LastUpdatedDetails(params?.value, params?.row.updatedBy)}
          >
            <div className={`ellipsis-text-container`}>
              {LastUpdatedDetails(params?.value, params?.row.updatedBy)}
            </div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
      ),
    new AGridColDef("status", "Status", false)
      .setMinWidth(80)
      .setFlex(0.6)
      .columnAlign("center")
      .editable(true)
      .renderCellComponent((params) => (
        <StatusCellComponent value={params.value} />
      ))
      .renderEditCellComponent((params) => (
        <StatusCellComponent
          value={rowForm?.status}
          handleChange={(val) => rowFormHandler(val, "status")}
        />
      )),
    new AGridColDef("action", "Actions", false)
      .setMinWidth(140)
      .columnAlign("center")
      // .editable(true)
      .setFlex(1)
      .renderCellComponent((params) => (
        <ActionsCellComponent
          mode={params.api.getRowMode(params?.id)}
          handleEditClick={handleEditClick}
          handleSaveClick={handleSaveClick}
          handleCancelClick={handleCancelClick}
          handleDeleteClick={handleDeleteClick}
          icon={true}
          cancelIcon={<CancelIcon
            className="mx-2 cursor"
            onClick={() => handleCancelClick(params)}
          />}
          // deleteIcon={true}
          params={params}
          editPermission={isUpdatePermission}
          deletePermission={isDeletePermission}
          customEditIcon
        />
      )),

  ];

  return (
    <>
      {loading && <ALoader position="fixed" />}
      <div className="mt-3">
        <ADataGrid
          removeWrapperContainer
          rowModesModel={rowModesModel}
          rows={rowData || []}
          columns={columns}
          rowId={(row) => row?.id}
          rowHeight={50}
          rowCount={totalRecords}
          loading={false}
          currentPage={currentPage}
          nextButtonHandler={nextButtonHandler}
          sx={{
            ...gridStyles,
          }}
          autoHeight
          paginationModel={{ page: currentPage, pageSize: currPageSize }}
        />
      </div>
    </>
  );

});


export default ListComponent;